import {fetchHeaders, patchHeaders} from "../../utils/headers";
import Constants from "../../utils/constants";

export const anomaliesService = {
    fetchAnomalies,
    fetchAnomaliesCount,
    resolveAnomalie,
    updateIntervention,
    updateConteneur,
};

/** Liste des anomalies non résolues */
function fetchAnomalies() {
    const requestOptions = fetchHeaders()

    const url = Constants.API_ROUTE_ANOMALIES + "?exists[resolvedAt]=false&itemsPerPage=500";

    return fetch(url, requestOptions)
        .then(handleResponse)
        .then(anomalies => {
            return anomalies["hydra:member"]
        });
}

/** Count des anomalies non résolues (badge menu) */
function fetchAnomaliesCount() {
    const requestOptions = fetchHeaders()

    return fetch(Constants.API_ROUTE_ANOMALIES_COUNT, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data.count
        });
}

/** Résolution manuelle : 'ignoree' ou 'patrimoine_maj' */
function resolveAnomalie(id, resolution) {
    const requestOptions = patchHeaders({resolution})
    const url = Constants.API_ROUTE_ANOMALIE.replace(':id', id);

    return fetch(url, requestOptions)
        .then(handleResponse);
}

/** Correction de l'intervention (le back auto-résout l'anomalie) */
function updateIntervention(id, values) {
    const requestOptions = patchHeaders(values)
    const url = Constants.API_ROUTE_INTERVENTION.replace(':id', id);

    return fetch(url, requestOptions)
        .then(handleResponse);
}

/** Mise à jour du conteneur ("le terrain a raison") */
function updateConteneur(id, values) {
    const requestOptions = patchHeaders(values)
    const url = Constants.API_ROUTE_CONTENEUR.replace(':id', id);

    return fetch(url, requestOptions)
        .then(handleResponse);
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }

        return data;
    });
}
